
import { $store } from '@/main';

export function importTranslations(arr, i18n, sub_key = "", translation_key = "title") {
    let languages = $store.getters["labels/languages"];
    let translations = new Array(languages.length);
    languages.forEach((elem, index) => {
        translations[index] = {};
        translations[index].locale = elem.code;
        translations[index].labels = {};
    });

    arr.forEach((ele) => {
        if (sub_key != '') {
            if ('data' in ele) {
                ele = ele[sub_key]['data'];
            } else {
                ele = ele[sub_key];
            }
        }

        if (ele) {
            if ('data' in ele) {
                ele = ele['data'];
            }
            if (ele) {
                if ('attributes' in ele) {
                    ele = ele.attributes;
                }
                var path = ele.key;

                let labels = ele.labels;
                if ('data' in ele.labels) {
                    labels = ele.labels.data;
                }
                labels.forEach((lab) => {

                    let label = lab;
                    if ('data' in lab) {
                        lab = lab['data'];
                    }
                    if ('attributes' in lab) {
                        label = lab.attributes;
                    }
                    let index = translations.findIndex((x) => x.locale === label.locale);
                    var value = label[translation_key];
                    var obj = translations[index].labels;
                    var parts = path.split("."), part;
                    var last = parts.pop();
                    // eslint-disable-next-line no-cond-assign
                    while ((part = parts.shift())) {
                        if (typeof obj[part] != "object") obj[part] = {};
                        obj = obj[part]; // update "pointer"
                    }
                    obj[last] = value;
                });
            }
        }
    });
    translations.forEach((elem) => {
        let old = i18n.getLocaleMessage(elem.locale);
        i18n.setLocaleMessage(elem.locale, {
            ...old,
            ...elem.labels,
        });
    });
}


